import { FieldValues, Path, UseFormRegister } from 'react-hook-form'
import { Input } from 'types/input'

interface SimpleCheckboxProps<T extends FieldValues> extends Input {
  register: UseFormRegister<T>
  name: Path<T>
  label: string
  handleChange?: (e: any) => any
}

const SimpleCheckbox = <T extends FieldValues>({
  register,
  name,
  label,
  handleChange,
  disabled,
  ...props
}: SimpleCheckboxProps<T>) => {
  const change = handleChange
    ? {
        onChange(e: any) {
          handleChange(e)
        },
      }
    : {}

  return (
    <>
      <input
        type="checkbox"
        id={name}
        {...register(name, { ...change })}
        disabled={disabled}
        {...props}
      />
      <label
        htmlFor={name}
        className={`pl-3 ${disabled ? 'text-gray-500' : ''} text-sm`}
      >
        {label}
      </label>
    </>
  )
}

export default SimpleCheckbox
